import { BalanceType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { i18next } from '@frontend/i18n';
import { Chip, ChipProps } from '@frontend/design-system';
import { styles } from './styles';

type BalanceTagProps = {
  balanceType: BalanceType;
} & ChipProps;

const BALANCE_TYPE_CONFIG: Record<
  BalanceType,
  { style: (typeof styles.balanceTag)[keyof typeof styles.balanceTag]; label: string }
> = {
  [BalanceType.BALANCE_TYPE_UNKNOWN]: {
    style: styles.balanceTag.default,
    label: i18next.t('Unknown', { ns: 'payments' }),
  },
  [BalanceType.BALANCE_TYPE_NEW]: {
    style: styles.balanceTag.new,
    label: i18next.t('New Balance', { ns: 'payments' }),
  },
  [BalanceType.BALANCE_TYPE_UPDATE]: {
    style: styles.balanceTag.update,
    label: i18next.t('Changed Balance', { ns: 'payments' }),
  },
  [BalanceType.BALANCE_TYPE_EXISTS]: {
    style: styles.balanceTag.exists,
    label: i18next.t('Outstanding Balance', { ns: 'payments' }),
  },
};

export const BalanceTag = ({ balanceType, ...rest }: BalanceTagProps) => {
  if (!balanceType) return null;

  const { style, label } = BALANCE_TYPE_CONFIG[balanceType] ?? {
    style: styles.balanceTag.default,
    label: i18next.t('Unknown', { ns: 'payments' }),
  };

  return (
    <Chip css={style} {...rest}>
      {label}
    </Chip>
  );
};
